module.exports = "<div>\n  <div class=\"container-fluid\">\n    <!-- <p>\n      flowchart works!\n    </p> -->\n    <div id=\"graph\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/project-view/flowchart/flowchart.component.html
// module id = ./src/app/projects/project-view/flowchart/flowchart.component.html
// module chunks = main